import { render, staticRenderFns } from "./goModel.vue?vue&type=template&id=17bc2263&scoped=true"
import script from "./goModel.vue?vue&type=script&lang=js"
export * from "./goModel.vue?vue&type=script&lang=js"
import style0 from "./goModel.vue?vue&type=style&index=0&id=17bc2263&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bc2263",
  null
  
)

export default component.exports